import type { SearchEpicentersParams } from "../../../../api/epicenter/search";
import { AbstractPanel } from "../../../../common/abstractconditionpanel";
import { allEqMechanismTypeIds, eqMechanismTypeIdToString } from "../../../../enums";
import hx from "../../../../utils/hydroxie";

/**
 * 震源検索→検索条件エリア→F-net情報パネル
 */
export class FnetPanel extends AbstractPanel<SearchEpicentersParams> {
    /**
     * 初期化処理を行う。
     * F-net検索条件のUI要素を生成し、イベントリスナーを設定する。
     */
    async init() {
        const elem = this.getElem();

        elem.replaceChildren(...this.#createElement());

        elem.addEventListener("change", () => {
            const params = this.#getParams();
            this.emit("update", params);
        });
    }

    #createElement() {
        return [
            hx("div", { className: "field" },
                hx("label", { className: "label" }, "F-netモーメントマグニチュード"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", className: "input is-small", name: "mwFrom" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", className: "input is-small", name: "mwTo" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "セントロイド深さ [km]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "1", className: "input is-small", name: "cmtDepthFrom" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "1", className: "input is-small", name: "cmtDepthTo" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "メカニズム解種別"),
                hx("div", { id: "eq_mechanism_type_ids", className: "control horizontal" },
                    allEqMechanismTypeIds.map((x) => {
                        return hx("label", { className: "label" },
                            hx("input", { type: "checkbox", id: `eqMechanismTypeId${x}`, value: "" + x, checked: true }),
                            eqMechanismTypeIdToString(x));
                    }))),

            hx("div", { className: "notification is-info is-light" },
                "F-netに関する検索項目を指定した場合、F-netから解析結果を公表していない震源(1997年以前の震源を含む)は検索結果に表示されません。"),
        ];
    }

    #getParams() {
        const mwFrom = this.getNumber("[name='mwFrom']");
        const mwTo = this.getNumber("[name='mwTo']");

        const eqMechanismTypeId = this.getChecked("[id^='eqMechanismTypeId']:checked", Number);

        const cmtDepthFrom = this.getNumber("[name='cmtDepthFrom']");
        const cmtDepthTo = this.getNumber("[name='cmtDepthTo']");

        return {
            mwFrom,
            mwTo,
            eqMechanismTypeId,
            cmtDepthFrom,
            cmtDepthTo,
        };
    }
}
